import { Box, BoxProps } from "@mui/material";
import { Flex } from "~/components/Flex";
import { TabOption } from "../../../types";
import { TabVariant } from "./TabVariant";
import { uniqBy } from "lodash-es";
import {
  AwsIcon,
  AzureIcon,
  CloudFormationIcon,
  ContainersIcon,
  DomainsHostsIcon,
  FolderOpenFilledIcon,
  GcpIcon,
  GithubIcon,
  GitlabIcon,
  GoogleWorkspaceIcon,
  KubernetesIcon,
  MacosIcon,
  Ms365Icon,
  OktaIcon,
  OperatingSystemsIcon,
  SaasIcon,
  SlackIcon,
  TerraformIcon,
  VmwareIcon,
  WifiGradientIcon,
  WindowsIcon,
} from "~/icons";

type TabsVariantProps = BoxProps & {
  options: TabOption[];
  selectedTab: string;
  onTabChange: (value: string) => void;
};

export const TabsVariant = ({
  options,
  selectedTab,
  onTabChange,
  ...restProps
}: TabsVariantProps) => {
  const variantOptions = uniqBy(options, "value");
  return (
    <Flex flexWrap={"wrap"} gap={2} {...restProps}>
      {variantOptions.map(({ label, value, icon }) => {
        return (
          <TabVariant
            key={value}
            isActive={selectedTab === value}
            label={label}
            icon={icon}
            onClick={() => {
              onTabChange(value);
            }}
          />
        );
      })}
    </Flex>
  );
};

export const VariantIcon = ({ type }: { type: string | null }) => {
  const name = type?.toLowerCase();

  if (!name)
    return (
      <Box
        sx={{
          width: 40,
          height: 10,
          backgroundColor: "background.default",
          boxShadow: 2,
        }}
      />
    );

  const svgStyles = { fontSize: 40 };

  if (name.includes("k8s")) return <KubernetesIcon sx={svgStyles} />;
  else if (name.includes("cloudformation"))
    return <CloudFormationIcon sx={svgStyles} />;
  else if (name.includes("aws")) return <AwsIcon sx={svgStyles} />;
  else if (name.includes("gcp")) return <GcpIcon sx={svgStyles} />;
  else if (name.includes("github")) return <GithubIcon sx={svgStyles} />;
  else if (name.includes("gitlab")) return <GitlabIcon sx={svgStyles} />;
  else if (name.includes("azure")) return <AzureIcon sx={svgStyles} />;
  else if (name.includes("vmware")) return <VmwareIcon sx={svgStyles} />;
  else if (name.includes("macos")) return <MacosIcon sx={svgStyles} />;
  else if (name.includes("os")) return <OperatingSystemsIcon sx={svgStyles} />;
  else if (name.includes("windows")) return <WindowsIcon sx={svgStyles} />;
  else if (name.includes("network_devices"))
    return <WifiGradientIcon sx={svgStyles} />;
  else if (name.includes("domains_and_hosts"))
    return <DomainsHostsIcon sx={svgStyles} />;
  else if (name.includes("saas_services")) return <SaasIcon sx={svgStyles} />;
  else if (name.includes("terraform")) return <TerraformIcon sx={svgStyles} />;
  else if (name.includes("google-workspace"))
    return <GoogleWorkspaceIcon sx={svgStyles} />;
  else if (name.includes("okta")) return <OktaIcon sx={svgStyles} />;
  else if (name.includes("ms365")) return <Ms365Icon sx={svgStyles} />;
  else if (name.includes("slack")) return <SlackIcon sx={svgStyles} />;
  else if (name.includes("container")) return <ContainersIcon sx={svgStyles} />;
  else return <FolderOpenFilledIcon sx={svgStyles} />;
};

export default TabsVariant;
